import IllegalStateError from '../../domain/illegal-state-error';
import ConflictError from '../../domain/conflict-error';
import UnauthorizedError from '../../domain/unauthorized-error';
import ForbiddenError from '../../domain/forbidden-error';
import NotFoundError from '../../domain/not-found-error';

let unauthorizedErrorInterceptor = null;

const setUnauthorizedErrorInterceptor = interceptor => {
  unauthorizedErrorInterceptor = interceptor;
};

const handleRestError = err => {
  const status = (err.response || {}).status || -1;
  if (status === 400) {
    const responseData = err.response.data || {};
    throw new IllegalStateError(
      responseData.message || 'Sorry, an error has occurred',
      responseData.code
    );
  } else if (status === 401) {
    if (unauthorizedErrorInterceptor) {
      return unauthorizedErrorInterceptor(err).then(() => ({}));
    } else {
      throw new UnauthorizedError('You are not authenticated, please relaunch the app');
    }
  } else if (status === 403) {
    throw new ForbiddenError((err.response.data || {}).message || 'This operation is forbidden');
  } else if (status === 404) {
    if (((err.config || {}).method || '').toUpperCase() === 'GET') {
      return {};
    } else {
      throw new NotFoundError('Not found');
    }
  } else if (status === 409) {
    const responseData = err.response.data || {};
    throw new ConflictError(responseData.message || 'Conflict', responseData.extraInfo);
  } else if (status === 500) {
    throw new IllegalStateError(
      (err.response.data || {}).message || 'Sorry, an error has occurred',
      null,
      {method: (err.config || {}).method, url: (err.config || {}).url}
    );
  }
  throw err;
};

const acerillRestErrorHandler = {
  setUnauthorizedErrorInterceptor,
  handleRestError,
};

export default acerillRestErrorHandler;
